import type { Nullable } from "../../@types/generic";

export const formatTemperature = (
    value: Nullable<number> | undefined,
    noDegree = false
): string => {
    if (value === null || value === undefined) {
        return "k.A.";
    }

    if (noDegree) {
        return value.toString();
    }

    // degree sign
    return `${value.toString()}${String.fromCharCode(176)}`;
};
